export const isBrowser = typeof window !== 'undefined';

export async function delayAsync(time: number): Promise<void> {
  return await new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}
